import ResourceManager from "@/components/admin/ResourceManager";
import { Field, ImageUploader } from "@/components/admin/Primitives";

export default function GalleryAdmin() {
  return (
    <ResourceManager
      resource="gallery"
      title="Gallery"
      subtitle="Photos from past events, parties, tournaments."
      defaults={{ title: "", image_url: "", category: "general" }}
      columns={[
        { key: "image_url", label: "Image" },
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="Title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} required testid="gallery-title" />
          <Field label="Category" value={form.category} onChange={(v) => setForm({ ...form, category: v })} testid="gallery-category" />
          <ImageUploader value={form.image_url} onChange={(v) => setForm({ ...form, image_url: v })} testid="gallery-image" />
        </>
      )}
    />
  );
}
